module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community-content"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "refreshing event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('svg', {
    attrs: {
      "width": "61px",
      "height": "50px",
      "viewBox": "0 0 61 50",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-127.000000, -2206.000000)",
      "stroke": _vm.getCorpHeaderColor,
      "stroke-width": "2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7-Copy-3",
      "transform": "translate(126.000000, 2175.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24.5374934,65.012267 C22.5790733,65.012267 19.243945,64.7900847 17.4429019,64.4053966 L9.23192587,72.6163727 L9.23192587,60.9879935 C4.80797411,58.0078696 2,53.639042 2,48.7553018 C2,39.7775843 11.4426225,32.4983366 23.0901862,32.4983366 C34.7383893,32.4983366 44.1803723,39.7775843 44.1803723,48.7553018 C44.1803723,57.7330193 34.7377498,65.012267 23.0901862,65.012267 L24.5374934,65.012267 Z M44.5204304,38.6240915 C47.1558084,41.7216246 48.702081,45.4588977 48.702081,49.4780554 C48.702081,58.8707981 40.2839121,66.7115128 29.1703176,68.4451542 C32.3177945,69.8889815 35.9795445,70.7332924 39.9091744,70.7332924 C41.8675945,70.7332924 43.756055,70.5109693 45.5570981,70.1262812 L53.7680741,78.3372573 L53.7680741,66.7114361 C58.1920252,63.7313122 61,59.3624846 61,54.4761865 C61,46.7198836 53.9484087,40.2476649 44.5204943,38.6240147 L44.5204304,38.6240915 Z",
      "id": "Page-1"
    }
  })])])])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-transform": "none"
    },
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v("Join the Conversation at "), (_vm.bannerEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")])]), _vm._v(" "), (_vm.bannerEvent && _vm.showRulesComp && _vm.showJoin(_vm.bannerEvent) && _vm.bannerEvent.type !== '3') ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.bannerEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.bannerEvent) ? _c('div', {
    staticClass: "communityBox"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    attrs: {
      "src": _vm.bannerEvent.img_url,
      "alt": _vm.bannerEvent.title,
      "title": _vm.bannerEvent.title
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.bannerEvent && _vm.bannerEvent.csvExpertsNames) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.bannerEvent.title) + " with " + _vm._s(_vm.replaceLastExpert(_vm.bannerEvent.csvExpertsNames, ',', ' & ')))]), _vm._v(" "), (_vm.bannerEvent) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.bannerEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.bannerEvent.start_date, 'str')) + "\n                        ")]), _vm._v(" "), (!_vm.showJoin(_vm.bannerEvent)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.bannerEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.bannerEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.bannerEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.bannerEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.bannerEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.bannerEvent.eventId)))]) : _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.bannerEvent.eventId)))])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.bannerEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share\n                        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.bannerEvent && _vm.showRulesComp && !_vm.showJoin(_vm.bannerEvent) && _vm.bannerEvent.type !== '3') ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp",
    class: {
      hidden: _vm.isHidden()
    }
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.bannerEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _c('div')]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    attrs: {
      "aria-label": "Share with"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "aria-label": "Corporate recipients",
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "aria-label": "Email recipients",
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "aria-label": "Type your message",
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      color: _vm.$a11yTextColor(_vm.getCorpButtonColor) + ' !important',
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24b2f4ca", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b2f4ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Event.vue